import { render, staticRenderFns } from "./TeacherInfoMaintenance.vue?vue&type=template&id=47a228e8&"
import script from "./TeacherInfoMaintenance.vue?vue&type=script&lang=ts&"
export * from "./TeacherInfoMaintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports